import moment from 'moment-timezone';
import React from 'react';
import utils from '../../../services/utils';
import CardBankPayout from '../../CardBankPayout/CardBankPayout';

import classes from './ResultOrigin.module.scss';

const ResultOrigin = ({ datePay, origin, methodForPay }) => {
  return (
    <>
      {datePay && <span className='medium-14'>{moment(datePay).format('DD [de] MMMM [del] YYYY [a las] HH:mm a')}</span>}

      <div>
        {origin.map(({ bankAccount, value }, idx) => (
          <div key={idx} className={classes.origin}>
            <span className={`${classes.color} medium-12`}>CUENTA ORIGEN {origin.length > 1 ? `#${idx + 1}` : ''}</span>
            {origin.length > 1 && (
              <span className='medium-14'>
                Total cuenta #{idx + 1}: {utils.moneyFormat(value)}
              </span>
            )}
            <CardBankPayout
              methodForPay={methodForPay}
              className={classes['card-bank']}
              bankId={bankAccount.bankId}
              subtypeLabel={bankAccount.subtypeLabel}
              bankLast4Digits={bankAccount.bankLast4Digits}
              name={bankAccount.name}
              identification={`${bankAccount.endUser.identificationTypeLabel} ${bankAccount.endUser.identificationNumber}`}
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default ResultOrigin;
